import { DemandOverviewApi } from '../demands-overview/api/demands-overview-api';
import { DemandsDetailApi } from '../demands-detail/api/demands-detail-api';
import { DemandsTopicsApi } from '../demands-topics/api/demands-topics-api';

export class DemandApi {
    constructor(protected baseUrl: string) {
        this.DemandOverview = new DemandOverviewApi(this.baseUrl);
        this.DemandDetail = new DemandsDetailApi(this.baseUrl);
        this.DemandTopics = new DemandsTopicsApi(this.baseUrl);
    }

    public DemandOverview: DemandOverviewApi;
    public DemandDetail: DemandsDetailApi;
    public DemandTopics: DemandsTopicsApi;
}
